import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    // Check if user is admin
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    if (user?.role !== 'admin') {
      navigate('/');
      return;
    }
    fetchDashboardStats();
  }, [isAuthenticated, user]);

  const fetchDashboardStats = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No token found');
        return;
      }
      
      const response = await axios.get('http://localhost:5000/api/reports/dashboard', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
      if (error.response?.status === 401) {
        // Token expired or invalid
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
      }
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Admin Dashboard</h1>
      
      {/* Stats Cards */}
      <div className="row">
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <h5>Total Students</h5>
              <h2>{stats.totals?.students || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <h5>Total Courses</h5>
              <h2>{stats.totals?.courses || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <h5>Total Enrollments</h5>
              <h2>{stats.totals?.enrollments || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <h5>Total Leads</h5>
              <h2>{stats.totals?.leads || 0}</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="card mt-4">
        <div className="card-body">
          <h5>Quick Actions</h5>
          <div className="d-flex flex-wrap gap-2">
            <button 
              className="btn btn-primary"
              onClick={() => setActiveTab('courses')}
            >
              📚 Manage Courses
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => setActiveTab('categories')}
            >
              📂 Manage Categories
            </button>
            <button 
              className="btn btn-success"
              onClick={() => navigate('/leads')}
            >
              📋 View Leads
            </button>
            <button 
              className="btn btn-info"
              onClick={() => setActiveTab('users')}
            >
              👥 Manage Users
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'courses' && (
        <div className="card mt-4">
          <div className="card-body">
            <h5>Course Management</h5>
            <p className="text-muted">Coming soon - Course management interface</p>
            <div className="alert alert-info">
              <strong>Tip:</strong> You can manage courses through the database or API for now.
            </div>
          </div>
        </div>
      )}

      {activeTab === 'categories' && (
        <div className="card mt-4">
          <div className="card-body">
            <h5>Category Management</h5>
            <p className="text-muted">Coming soon - Category management interface</p>
          </div>
        </div>
      )}

      {activeTab === 'users' && (
        <div className="card mt-4">
          <div className="card-body">
            <h5>User Management</h5>
            <p className="text-muted">Coming soon - User management interface</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;